const getToDoCount = () => {
  const count = localStorage.getItem("ToDoCount");
  return count ? parseInt(count, 10) : 0;
};
const getTFaxCount = () => {
  const faxCount = localStorage.getItem("unreadFaxCount");
  return faxCount ? parseInt(faxCount, 10) : 0;
};
const getTMessageCount = () => {
  const MessageCount = localStorage.getItem("unreadMessageCount");
  return MessageCount ? parseInt(MessageCount, 10) : 0;
};
const getSidebarData = () => [
  {
    label: "Dashboard",
    icon: "mdi mdi-view-dashboard",
    url: "/dashboard",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Dasboard_View",
    // badgeValue: "3"
  },
  {
    label: "Schedular",
    icon: "mdi mdi-calendar",
    url: "/Schedular",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Scheduler_view",
  },
  {
    label: "Forms/Templates",
    icon: "mdi mdi-file-document",
    url: "/fromstemp",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    // badgeValue: "3"
    permissionKey: "Forms_View",
  },

  {
    label: "Patient",
    icon: "mdi mdi-heart-pulse",
    url: "/Patient",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Patient_view",
  },
  {
    label: "Authorization",
    icon: "mdi mdi-lock",
    url: "/Authorization",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Authorization_View",
  },
  {
    label: "To-Do List",
    icon: "mdi mdi-message-outline",
    url: "/Todolist",
    issubMenubadge: true,
    badgeValue: getToDoCount(),
    bgcolor: "bg-primary",
    permissionKey: "To_Do_List_View",
  },
  {
      label: "Message",
      icon: "mdi mdi-email",
      url: "/Messages",
      issubMenubadge: true,
       badgeValue: getTMessageCount(),
      bgcolor: "bg-primary",
      permissionKey: "View_Messages",

  },
  {
    label: "Carriers",
    icon: "mdi mdi-shield-account-outline",
    url: "/Insuranceplan",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Carriers_view",
  },

  {
    label: "Contacts",
    icon: "mdi mdi-contacts",
    url: "/Contants",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Contacts_View",
  },

  {
    label: "Claim",
    icon: "mdi mdi-cash-usd",
    url: "/Claim",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Claim_view",
  },
  {
    label: "Fax",
    icon: "mdi mdi-fax",
    url: "/Fax",
    issubMenubadge: true,
    badgeValue: getTFaxCount(),
    bgcolor: "bg-primary",
    labelClass: "text-xs whitespace-nowrap",
    permissionKey: "Fax_view",
  },
  {
    label: "Reports",
    isMainMenu: true,
    permissionKey: "AgingReport_view",
  },
  {
    label: "Aging Report",
    icon: "mdi mdi-file-clock",
    url: "/AgingReports",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "AgingReport_view",
  },
  {
    label: "Setting",
    isMainMenu: true,
    permissionKey: "Templates_view",
  },

  {
    label: "User",
    icon: "mdi mdi-account-circle-outline",
    url: "/User",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "User_view",
  },
  {
    label: "SOAP Note Temp",
    icon: "mdi mdi-file-document",
    url: "/Templates",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    labelClass: "text-xs whitespace-nowrap",
    permissionKey: "Templates_view",
  },

  {
    label: "Practices",
    icon: "mdi mdi-briefcase-outline",
    url: "/Practices",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Practices_view",
  },
  {
    label: "Provider",
    icon: "mdi mdi-briefcase-account-outline",
    url: "/Provider",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Provider_view",
  },

  {
    label: "Diagnosis",
    icon: "mdi mdi-medical-bag",
    url: "/Diagnosis",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Diagnosis_view",
  },
  {
    label: "Procedures",
    icon: "mdi mdi-hospital-building",
    url: "/Procedures",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Procedure_view",
  },
  {
    label: "Modules",
    icon: "mdi mdi-view-module",
    url: "/Modules",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    permissionKey: "Modules_View",
  },

  // {
  //     label: "OSAPAGE",
  //     icon: "mdi mdi-home-variant-outline",
  //     url: "/OSAPAGE",
  //     issubMenubadge: true,
  //     bgcolor: "bg-primary",
  // },
  // {
  //     label: "VOBPAGE",
  //     icon: "mdi mdi-home-variant-outline",
  //     url: "/VOBPAGE",
  //     issubMenubadge: true,
  //     bgcolor: "bg-primary",
  // },
];
export default getSidebarData;
